<template>
    <div>
        <app-navigation></app-navigation>
        <div class="relative m-0">
            <img src="https://source.unsplash.com/hes6nUC1MVc/2400X1603/" alt="empty classroom"
                class="m-4"
            >
            <div class="absolute w-5/6 p-4 bg-black bg-opacity-50 m-8 top-0">
                <p class="font-sans text-xl text-white italic">Uh oh! Seems like you are lost in a dizzy classroom memory!</p>
            </div>
        </div>    
    </div>
</template>

<script>
export default {
    name: 'Error Page',
}
</script>

<style scoped>
    img {
        height: 84vh;
        width: 98%
    }
</style>


// WEBPACK FOOTER //
// src/components/ErrorPage.vue